import { render, staticRenderFns } from "./fengGeTips.vue?vue&type=template&id=ef443472&"
import script from "./fengGeTips.vue?vue&type=script&lang=js&"
export * from "./fengGeTips.vue?vue&type=script&lang=js&"
import style0 from "./fengGeTips.vue?vue&type=style&index=0&id=ef443472&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports